import React, { FC, useEffect, useState } from 'react';
import { useDebouncedValue } from '@mantine/hooks';
import { TabletFilterOptionsList } from './shared/TabletFilterOptionsList';
import { TabletFilterContainer } from './shared/TabletFilterContainer';
import { FilterOption } from './shared/TabletFilterOptionsList';
import { SelectedItem } from 'components/EmployedsFilters/EmployedsAdaptiveFilter';

export interface AdaptiveFilterOption {
  id: string;
  label: string;
  count?: number;
  inn?: string;
}

export interface AdaptiveFilterProps {
  options: AdaptiveFilterOption[];
  selectedValues: SelectedItem[];
  onChange: (values: SelectedItem[]) => void;
  onReset: () => void;
  onApply: () => void;
  searchPlaceholder?: string;
  serverSearch?: boolean;
  onServerSearchChange?: (search: string) => void;
  hasNextPage?: boolean;
  isFetchingMore?: boolean;
  onLoadMore?: () => void;
  isLoading?: boolean;
  showSearch?: boolean;
  singleSelect?: boolean;
}

export const TabletAdaptiveFilter: FC<AdaptiveFilterProps> = ({
  options,
  selectedValues,
  onChange,
  serverSearch,
  onServerSearchChange,
  hasNextPage,
  isFetchingMore,
  onLoadMore,
  isLoading,
  showSearch = true,
  singleSelect = false,
}) => {
  const [searchInput, setSearchInput] = useState('');
  const [debouncedSearch] = useDebouncedValue(searchInput.trim(), 300);

  useEffect(() => {
    if (!serverSearch) return;
    onServerSearchChange?.(debouncedSearch);
  }, [debouncedSearch, onServerSearchChange, serverSearch]);

  const mappedOptions: FilterOption[] = options
    .filter(
      (option) =>
        option.label !== null && option.label !== undefined && option.label.trim() !== '',
    )
    .map((option) => ({
      value: option.id,
      label: option.label,
      count: option.count,
      inn: option.inn,
    }));

  return (
    <TabletFilterContainer>
      <TabletFilterOptionsList
        options={mappedOptions}
        selectedValues={selectedValues}
        showSearch={showSearch}
        onChange={onChange}
        serverSearch={serverSearch}
        searchValue={searchInput}
        onSearchValueChange={setSearchInput}
        hasNextPage={hasNextPage}
        isFetchingMore={isFetchingMore}
        onLoadMore={onLoadMore}
        isLoading={isLoading}
        singleSelect={singleSelect}
      />
    </TabletFilterContainer>
  );
};
